import React, { Component } from 'react';
import {WARP_BUTTON} from 'constants/contextual-help.js';
import {setContextualHelp} from "actions/index.js";
import { connect } from "react-redux";
import WarpEffect from 'effects/midi/WarpEffect.js';

class WarpButton extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    onClick() {
        this.props.track.warp();
        this.setState(this.state);

        if (this.props.onWarp) {
            this.props.onWarp();
        }
    }

    isWarped() {
        let effects = this.props.track.midiEffects.effects.filter(
            x => x.name === 'Warp');
        return effects
            .filter(x => x.enabled).length > 0;
    }

    render() {
        let className = this.props.isWarped ? "warp-button selected pushable" : "warp-button pushable";
        return (
            <div
              onMouseOver={() => this.props.setContextualHelp(WARP_BUTTON)}
              onMouseLeave={() => this.props.setContextualHelp(undefined)}
              onClick={() => this.onClick()}
              className={className}>Warp</div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let subSequenceId = props.track.subSequence.id;
    return {
        isWarped: state.tracks.trackWarps[subSequenceId] &&
            state.tracks.trackWarps[subSequenceId][props.track.trackNumber]
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
};
 

export default connect(mapStateToProps, mapDispatchToProps)(WarpButton);
